let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("deNfx")).then(() => parcelRequire('bheWJ'));